import React from 'react';
import TabPanel from 'react-tab-panel';

import 'react-tab-panel/base.css';
import './TabPanelControl.scss';

class TabPanelControl extends React.Component {

    render() {
        return (
            <TabPanel className="TabPanelControl" {...this.props}>
                {this.props.children}
            </TabPanel>
        );
    }
}

export default TabPanelControl;



// WEBPACK FOOTER //
// ./client/components/TabPanelControl/TabPanelControl.js